import React, { Dispatch } from 'react'

import './HistogramWrapper.scss'
import { IReduxAction, IReduxState } from '../../../utils/ReduxStore'
import { connect } from 'react-redux'
import SeatHistogram, { IResultCount } from './SeatHistogram'
import PartyResultMap from '../../../models/PartyResultMap'
import PartyResult from '../../../models/PartyResult'
import Party from '../../../models/Party'
import OutcomeOdds from '../OutcomeOdds'

interface ISeatCountDictionary {
  [partyKey: string]: {
    [seatCount: number]: number
  }
}

interface IDispatchProps {
  generateOutcome: () => void
}

interface IStateProps {
  outcomes: PartyResultMap[]
}

interface IProps extends IDispatchProps, IStateProps {}

interface IState {
  outcomes: PartyResultMap[]
}

class HistogramWrapper extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      outcomes: []
    }
  }

  public componentDidUpdate(): void {}

  public componentDidMount(): void {}

  protected initializeSeatCountDictionary(): ISeatCountDictionary {
    const dictionary: ISeatCountDictionary = {}

    Party.allPartyKeys().forEach((partyKey): void => {
      dictionary[partyKey] = {}
      for (let i = 0; i <= 338; i++) {
        dictionary[partyKey][i] = 0
      }
    })

    return dictionary
  }

  public outcomesToSeatCount(outcomes: PartyResultMap[]): IResultCount[] {
    const seatCountDictionary = this.initializeSeatCountDictionary()

    // First build a dictionary with all possible seat counts
    outcomes.forEach((outcome): void => {
      Object.values(outcome.results()).forEach((result: PartyResult): void => {
        const partyKey = result.party.code
        const seatCount = result.seatCount
        seatCountDictionary[partyKey][seatCount] += 1
      })
    })

    // Now reduce the dictionary so we only have the seat counts that were > 0
    const resultCountData: IResultCount[] = []

    Object.keys(seatCountDictionary).forEach((partyKey: string): void => {
      Object.keys(seatCountDictionary[partyKey]).forEach(
        (seatCountKey: string): void => {
          if (+seatCountKey > 0) {
            // Ignore results where zero seats are earned
            resultCountData.push({
              party: partyKey,
              color: Party.fromKey(partyKey).rgbColor,
              seats: +seatCountKey,
              count: +seatCountDictionary[partyKey][+seatCountKey]
            })
          }
        }
      )
    })

    return resultCountData
  }

  public render(): JSX.Element {
    return (
      <div className="HistogramWrapper row">
        <div className="col">
          <h2>Distribution of likely outcomes</h2>
          <p>
            This histogram shows the likelihood of seats won and election
            victory outcomes given the polling support provided in the sliders
            above.
          </p>
          <OutcomeOdds outcomes={this.props.outcomes} />
          <SeatHistogram
            resultCountData={this.outcomesToSeatCount(this.props.outcomes)}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  outcomes: state.outcomes
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  generateOutcome: (): void => {
    dispatch({ type: 'GENERATE_OUTCOME' })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistogramWrapper)
